/**
 * 폼 프리셋 — 모달 폼(FormModal/FormField)의 라벨·간격 규격.
 * 모달 입력은 MUI floating label 대신 "입력창 위 고정 라벨" 패턴을 쓴다
 * (라벨이 항상 보여서 스캔이 빠르고, 한글 라벨이 잘리지 않는다).
 */
export const createFormPresets = (tokens) => ({
    // 라벨 + 입력창 한 묶음(FormField)의 골격 — 세로 배치, 라벨과 입력창 사이 6px.
    field: {
        display: "flex",
        flexDirection: "column",
        gap: 0.75,                                 // 라벨-입력창 간격 (6px)
    },
    // 입력창 위 고정 라벨.
    label: {
        fontSize: 12,                              // 입력값(14px)보다 작게 — 보조 정보 위계
        fontWeight: 700,
        color: tokens.colors.textSecondary,        // 본문보다 연한 회색
        lineHeight: 1.2,
    },
    // 필수 항목 표시(*) — 라벨 앞에 빨간 별표.
    requiredMark: {
        color: tokens.colors.error,
        fontWeight: 800,
        mr: 0.4,                                   // 별표와 라벨 사이 간격
    },
    // 모달 본문(DialogContent) — 필드들을 16px 간격으로 세로 나열.
    dialogContent: {
        display: "flex",
        flexDirection: "column",
        gap: 2,                                    // 필드 사이 간격 (16px)
        pt: "20px !important",                     // MUI 가 DialogContent 상단 padding 을 0 으로 죽이는 것을 복원
    },
});
